import { render, staticRenderFns } from "./students-messages.vue?vue&type=template&id=692766d6&"
import script from "./students-messages.vue?vue&type=script&lang=js&"
export * from "./students-messages.vue?vue&type=script&lang=js&"
import style0 from "./students-messages.vue?vue&type=style&index=0&id=692766d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports